import React , { useState } from 'react';
import { endpoints } from '../../utils/Constants';
import { newCharterRequestShape } from '../../utils/Shapes';
import { createCharterRequestYup } from '../../utils/YupShapes';
import useFetchSimple from '../../Services/useFetchSimple';
import IndicativePrice from './LoginPanels/IndicativePrice';
import { Modal as ModalStrap } from 'reactstrap';
import {Button }from 'reactstrap'
import FormContainer from '../Models/FormContainer';
import { useAlert } from '../../Services/AlertContext';
import { useHistory } from 'react-router-dom';
import CharterRequestDetail from '../Editors/CharterRequestDetail';
import { useAuth } from '../../Services/AuthContext';
import dayjs from 'dayjs'
import { base64Encode } from '../../utils/Helpers';

const NewCharterRequest = () => {
    const alert = useAlert();
    const [auth] = useAuth();
    const history = useHistory();
    const fetch = useFetchSimple();
    const clientId = auth.Role === 'Admin' ? null : auth.clientId || auth.clientDepartmentId || auth.clientStaffId; 
    const newCR = auth && { ...newCharterRequestShape, clientId};
    const [indicitavePrice, setIndicitavePrice] = useState(); 
    const submitNewRequest = (values, actions) => {
        let { routes, ...request } = { ...values };
        request.routes = routes.map((x) => {

            const departTimeStr = dayjs(x.viewDepartDate).format('YYYY-MM-DD') + ' ' + x.viewDepartTime.format('HH:mm:ss');
            const departTime = dayjs(departTimeStr);
            const dateStart = departTime.format('YYYY-MM-DDTHH:mm:ss');
            if (!x.passengerRange) {
                x.passengerRange_Min = 0;
                x.passengerRange_Max = 0;
            }
            x.manifest = x.manifest?.map((y) => {
                y.passengerWeight = parseInt(y.passengerWeight ? y.passengerWeight : '0');
                y.freightWeight = parseInt(y.freightWeight ? y.freightWeight : '0');
                y.cargoWeight = parseInt(y.cargoWeight ? y.cargoWeight : '0');
                return y;
            }); 
            x.departTime = dateStart;
            return x;
        });    
          
        let requestBody = JSON.stringify(request);

        requestBody = JSON.stringify({ encodedData: base64Encode(requestBody) });        

        fetch(endpoints.newCharterRequest, { method: 'POST', headers: {
                 'Content-Type': 'application/json'
             },            
            body: requestBody }).then((result) => {
            alert({
                title: "Submitted OK!", body:<h2>Please wait for us to confirm your charter, and then watch the offers roll in</h2>, onDismiss:()=> history.push('/charterRequests/Me/New/') });
            actions.setSubmitting(false);
        }, (error) => {
                alert({ title: "Submit failed!", body: JSON.stringify(error) })
            actions.setSubmitting(false);
        })                
      
    }
    return newCR && <FormContainer initialValues={newCR} validationSchema={createCharterRequestYup} onSubmit={submitNewRequest} edit newRequest >
        <ModalStrap  size={"lg"} style={{ marginTop: '100px', width: '80%' }} isOpen={ indicitavePrice}  >
             <IndicativePrice onClose={() => setIndicitavePrice(false)} /> 
        </ModalStrap>

        <div style={{ backgroundColor: '#3E4D57', color: 'white', display: 'flex', marginBottom: '30px', justifyContent:'space-between' }}><h1 style={{ fontHeight: '38px', margin: '20px' }}>New Charter Request</h1><Button color="primary" className="float-right" onClick={() => setIndicitavePrice(true)} ><h4>Indicative Price</h4></Button></div>
        <CharterRequestDetail newRequest />
    </FormContainer>

}

export default NewCharterRequest;